export default {
    Email: 'Email',
    ConfirmEmail: 'Konfirmasi email',
    Password: 'Kata sandi',
    Verificationcode: 'Kode verifikasi',
    AlreadyhaveaHitPawaccountLogin: 'Sudah punya akun HitPaw? Masuk',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
        'Dengan mendaftar, Anda menyetujui Layanan Penggunaan dan Kebijakan Privasi kami',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
        'Dengan masuk, Anda menyetujui Layanan Penggunaan dan Kebijakan Privasi kami',
    Byproceedingyouagreetoour: 'Dengan masuk, Anda menyetujui ',
    ServicesofUse: 'Layanan Penggunaan',
    and: ' dan ',
    PrivacyPolicy: 'Kebijakan Privasi',
    last: ' kami.',
    TheEmailformatisincorrect: 'Format email salah',
    Pleaseenterthesameemailinbothfields: 'Silakan masukkan email yang sama di kedua bidang.',
    Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
        'Kata sandi harus terdiri dari 8-50 karakter dan berisi setidaknya dua kategori di antara yang berikut: angka, huruf, atau karakter khusus.',
    Incorrectverificationcode: 'Kode verifikasi salah',
    ThisEmailhasbeenregisteredpleasechooseanother:
        'Email ini telah terdaftar, silakan pilih yang lain.',
    Cannotbeemptyhere: 'Tidak boleh kosong di sini.',
    Rememberme: 'Ingat saya',
    ForgotPassword1: 'Lupa kata sandi?',
    NotaregistereduseryetSignUp: 'Belum terdaftar sebagai pengguna? Daftar',
    Notaregistereduseryet1: 'Belum terdaftar sebagai pengguna? ',
    Notaregistereduseryet2: 'Daftar',
    NoaccountfoundwiththatEmailaddress: 'Tak ada Akun dengan email tersebut',
    YourEmailaddressorpasswordwasincorrectPleasetryagain:
        'Alamat email atau kata sandi Anda salah. Silakan coba lagi.',
    ForgotPassword2: 'Lupa Kata Sandi',
    GetVerificationCode: 'Dapatkan Kode Verifikasi',
    VerifyEmail: 'Verifikasi Email',
    Ithasbeensenttoyourmailboxpleasecheckit: 'Sudah terkirim ke mailbox anda, silahkan dicek',
    PleaseinputEmailaddress: 'Silakan masukkan alamat email',
    TheEmailisnotregistered: 'Email tidak terdaftar',
    Invalidverificationcodepleasereenterthecorrectone:
        'Kode verifikasi tidak valid, masukkan kembali kode yang benar',
    Resetpassword: 'Setel ulang kata sandi',
    Emailaddressverificationsucceeded: 'Verifikasi alamat email berhasil',
    Pleaseresetyourpassword: 'Silakan atur ulang kata sandi Anda',
    Enteranewpassword: 'Masukan kata sandi yang baru',
    Confirm: 'Konfirmasi',
    Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
        'Kata sandi baru harus terdiri dari 8-50 karakter, terdiri dari huruf atau angka atau campuran huruf + angka',
    Passwordresetsuccessfully: 'Reset kata sandi berhasil',
    Name: 'Nama',
    GetCode: 'Dapatkan Kode',
    Loginsuccessful: 'Berhasil masuk',
    Loginfailed: 'Gagal masuk',
    Signupsuccessful: 'Pendaftaran berhasil',
    Signupfailed: 'Pendaftaran gagal',
    Getpassword: 'Dapatkan password',
    Authorizationhasexpiredpleaseloginagain:
        'Autorisasi telah kedaluwarsa, silakan masuk lagi.',
    Sorrysomethingwentwrongpleasetryagainlater:
        'Maaf, terjadi kesalahan, harap coba lagi nanti.',
    Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
        'Terlalu banyak permintaan yang sama dibuat dalam waktu singkat, harap coba lagi nanti.',
    Couldntfindyouraccountorthepasswordisincorrect:
        'Tidak dapat menemukan akun Anda, atau kata sandi salah.',
    Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
        'Anda mencoba untuk mengakses fungsi berbayar, harap berlangganan terlebih dahulu.',
    Accessdeniedfortheunauthorizedrequest: 'Akses ditolak untuk permintaan yang tidak sah.',
    Alreadyhaveaccount: 'Sudah ada rekening?',
    SignUpwithemail: 'Tandatangan dengan email',
    Securityverification: 'Verifikasi keamanan',
    Pleaseenterthecorrectemailaddress: 'Silakan masukkan alamat email yang benar!',
    PleaseInputverificationCode: 'Silakan masukkan kode verifikasi!',
    Pleaseenterthesamepasswordinbothfields:
        'Silakan masukkan kata sandi yang sama di kedua bidang!',
    or: 'atau',
    ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
        'Kata sandi baru yang Anda masukkan sama dengan kata sandi lama Anda. Masukkan kata sandi yang berbeda',
    YourpasswordwasincorrectPleasetryagain: 'Kata sandi Anda tidak tepat. Silakan coba lagi.',
    reg400: 'Maaf, terjadi kesalahan, harap coba lagi nanti.',
    reg400223: ' Email dan kode tidak cocok, harap periksa',
    reg400224: 'Token sudah kedaluwarsa',
    500: 'Galat sisi server!',
    Login: 'Login',
    exceed6Times: 'Uji coba Anda telah habis hari ini, harap tingkatkan ke Pro untuk mengakses semua fitur premium.',
    exceed20M: "Ukuran file untuk akun gratis tidak boleh melebihi 20MB, harap tingkatkan ke Pro untuk mengakses semua fitur premium."
}